import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const UserThumbnail = (props) => {

    const user = useSelector((state) => state.auth.userThumbnail);
    const [userDetails, setUserDetails] = useState(user);

    useEffect(() => {
        if (props.currentUser) {
            setUserDetails(user);
        }
        else
            setUserDetails(props.data);
    }, []);


    return (
        <>
            {!props.isSystem && <div className={"userThumbnail-avatar " + props.className}>
                {userDetails && userDetails.profileImage && userDetails.profileImage != "NA" && <img className="avatar-img" src={userDetails.profileImage} />}
                {userDetails && (!userDetails.profileImage || userDetails.profileImage == "NA") && userDetails.firstName && <span>{(userDetails.firstName[0].toUpperCase() + "" + userDetails.lastName[0].toUpperCase())}</span>}
            </div>
            }
            {props.isSystem && <div className={"userThumbnail-avatar " + props.className}>
                {<div className="avatar-img"></div>}
            </div>
            }
        </>
    );
};

export default UserThumbnail;